import { IGatheringChatItem } from '../../features/ActionsBar/Gathering/GatheringChat/types';
import { addListener } from '../common';

// LOBBY
export const onAccepted = addListener<any>('/admitted');
export const onRejected = addListener<any>('/denied');

// INTERNAL
export const onGuestJoined = addListener<any>(
  '/voice-channel/guest/lobby/joined',
); // Usuário solicitou pra entrar na sala
export const onGuestAccepted = addListener<any>(
  '/voice-channel/guest/lobby/accepted',
); // Usuário foi aceito
export const onGuestLeft = addListener<any>('/voice-channel/guest/lobby/left'); // Usuário saiu do lobby

// Gathering Session
export const onNewSession = addListener<any>('/voice-channel/new-session');

export const onGatheringChatNewMessage = addListener<IGatheringChatItem>(
  '/chat-session/message/new',
);
export const onGatheringUpdateMessage = addListener<IGatheringChatItem>(
  '/chat-session/message/update',
);
export const onGatheringDeleteMessage = addListener<IGatheringChatItem>(
  '/chat-session/message/delete',
);
